<div mat-dialog-content>
    <div class="wrapper">
        <img
            src="{{ DEPLOY_URL }}/assets/images/missing.png"
            [src]="imageUrl"
            style="height: 100%; width: 100%; object-fit: fill"
            alt="announcement" />
    </div>
    <mat-icon aria-hidden="true" class="close-btn" (click)="close()" data-test="announcement-close">close</mat-icon>
</div>
